import React from "react";
import { createPortal } from "react-dom";
import PropTypes from "prop-types";
import { CDropDown } from "@appcues/component-library";
import { useBoundingBox } from "hooks/useBoundingBox";

import ProfileAttributeFlyout from "./ProfileAttributeFlyout";

const ProfileAttributeOption = ({ children, ...restProps }) => {
  const { value: name, isFocused } = restProps;

  const [{ x, y, width, height }, ref] = useBoundingBox(!isFocused);

  return (
    <div ref={ref}>
      <CDropDown.Option {...restProps}>
        {children}
        {isFocused
          ? createPortal(
              <ProfileAttributeFlyout
                name={name}
                top={y - height / 2}
                left={x + width}
              />,
              document.body
            )
          : null}
      </CDropDown.Option>
    </div>
  );
};

ProfileAttributeOption.propTypes = {
  children: PropTypes.node,
  value: PropTypes.string,
  isFocused: PropTypes.bool
};

export default ProfileAttributeOption;
